import { useOutletContext } from "react-router-dom";

export interface NavbarInitiativeContext {
  selectedInitiative: string;

  selectedInitiativeName: string;
  setSelectedInitiative: (next: string) => void;
}

export const useNavbarInitiative = (): NavbarInitiativeContext => {
  const ctx = useOutletContext<NavbarInitiativeContext | undefined>();
  return (
    ctx ?? {
      selectedInitiative: "all",
      selectedInitiativeName: "",
      setSelectedInitiative: () => {},
    }
  );
};
